module.exports = __webpack_public_path__ + "static/media/Happister.e88a8b09.png";